import { render, staticRenderFns } from "./ChooseSubscriptionPlan.vue?vue&type=template&id=863c2f92&scoped=true&"
import script from "./plan.js?vue&type=script&lang=js&"
export * from "./plan.js?vue&type=script&lang=js&"
import style0 from "./ChooseSubscriptionPlan.vue?vue&type=style&index=0&id=863c2f92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863c2f92",
  null
  
)

export default component.exports